const endpoints = {
    users:'/administracion/user',
    permissions:'/administracion/permissions',
    subdirecciones:'/administracion/subdirecciones',
    direccionregional:'/administracion/direccion-regional'
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}